import script from "./Redirect.vue?vue&type=script&lang=ts"
export * from "./Redirect.vue?vue&type=script&lang=ts"

export default script